import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface IFileFilterEditItem extends IEditItem {
    code: string;
    name: string;
    modifyUser: IModifyUser;
}

export class FileFilterEditItem extends EditItem implements IFileFilterEditItem {
    code: string;
    name: string;
    modifyUser: IModifyUser;

    constructor();
    constructor(obj: IFileFilterEditItem);
    constructor(obj?: any) {
        super(obj);
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}